import { c as _c } from "react/compiler-runtime";
import { getAriaLabel } from '@bridge/utils';
import { Textarea } from '../../components';
import { FieldShell } from './FieldShell';
import { getFieldIds } from './utils';
import type { FieldValues } from 'react-hook-form';
import type { BaseComponentProps, BaseFieldProps } from './types';
export type TextareaComponentProps = BaseComponentProps<React.ElementType> & {
  placeholder?: string;
};
interface TextareaFieldProps<TFieldValues extends FieldValues> extends BaseFieldProps<TFieldValues> {
  componentProps: TextareaComponentProps;
}
export function TextareaField(t0) {
  const $ = _c(24);
  const {
    field,
    fieldConfig,
    fieldState,
    labelSize: t1,
    componentProps
  } = t0;
  const labelSize = t1 === undefined ? "lg" : t1;
  let componentDisabled;
  let id;
  let restComponentProps;
  if ($[0] !== componentProps) {
    ({
      id,
      disabled: componentDisabled,
      ...restComponentProps
    } = componentProps);
    $[0] = componentProps;
    $[1] = componentDisabled;
    $[2] = id;
    $[3] = restComponentProps;
  } else {
    componentDisabled = $[1];
    id = $[2];
    restComponentProps = $[3];
  }
  const isDisabled = field.disabled || componentDisabled;
  let t2;
  if ($[4] !== fieldConfig || $[5] !== fieldState || $[6] !== id) {
    t2 = getFieldIds(fieldConfig, fieldState, id);
    $[4] = fieldConfig;
    $[5] = fieldState;
    $[6] = id;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const ids = t2;
  const t3 = ids.describedBy;
  const t4 = ids.isInvalid;
  let t5;
  if ($[8] !== fieldConfig.label) {
    t5 = getAriaLabel(fieldConfig.label);
    $[8] = fieldConfig.label;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== field || $[11] !== ids.describedBy || $[12] !== ids.fieldId || $[13] !== ids.isInvalid || $[14] !== isDisabled || $[15] !== restComponentProps || $[16] !== t5) {
    t6 = <Textarea {...field} {...restComponentProps} aria-describedby={t3} aria-invalid={t4} aria-label={t5} disabled={isDisabled} id={ids.fieldId} />;
    $[10] = field;
    $[11] = ids.describedBy;
    $[12] = ids.fieldId;
    $[13] = ids.isInvalid;
    $[14] = isDisabled;
    $[15] = restComponentProps;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== fieldConfig || $[19] !== fieldState || $[20] !== ids || $[21] !== labelSize || $[22] !== t6) {
    t7 = <FieldShell fieldConfig={fieldConfig} fieldState={fieldState} ids={ids} labelSize={labelSize}>{t6}</FieldShell>;
    $[18] = fieldConfig;
    $[19] = fieldState;
    $[20] = ids;
    $[21] = labelSize;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}